module.exports = __webpack_public_path__ + "img/3.04.thmb.155aa66c.jpg";